import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  doc,
  where,
} from 'firebase/firestore';
import { db } from '../../../firebase';
import { tenantQuery } from '../../../utils/firestoreHelpers';

const COL = 'users';

/** Eski string formatını nesneye normalize eder (backward compat). */
const normalizePhone = (phone) => {
  if (!phone) return { countryCode: '+90', number: '' };
  if (typeof phone === 'string') return { countryCode: '+90', number: phone };
  return phone;
};

/**
 * Belirli bir işletmeye ait aktif çalışanları alfabetik sırayla çeker.
 * tenantQuery ile businessId filtresi zorunlu uygulanır.
 */
export async function fetchEmployeesByBusiness(businessId) {
  const q = tenantQuery(
    collection(db, COL),
    businessId,
    where('role', '==', 'employee'),
    where('status', '==', 'active')
  );
  const snap = await getDocs(q);
  return snap.docs
    .map((d) => ({ id: d.id, ...d.data(), phone: normalizePhone(d.data().phone) }))
    .sort((a, b) => a.name.localeCompare(b.name, 'tr', { sensitivity: 'base' }));
}

/** Yeni çalışan ekler. businessId otomatik eklenir. */
export async function addEmployee(employeeData, businessId) {
  await addDoc(collection(db, COL), { ...employeeData, businessId });
}

/** Mevcut çalışanı günceller. */
export async function updateEmployee(employeeId, updateData) {
  await updateDoc(doc(db, COL, employeeId), updateData);
}

/** Soft delete — status: "deleted" (deleteDoc asla kullanılmaz). */
export async function softDeleteEmployee(employeeId) {
  await updateDoc(doc(db, COL, employeeId), { status: 'deleted' });
}

/**
 * Aktif hizmetleri {id, name, type} formatında döndürür.
 * Prim ayarlarında "hizmet bazlı oran" dropdown'ı için kullanılır.
 *
 * TODO: services-catalog feature migrate edilince buradan kaldırılacak;
 *       features/services-catalog'dan import edilecek.
 */
export async function fetchActiveServices(businessId) {
  const q = tenantQuery(
    collection(db, 'services'),
    businessId,
    where('status', '==', 'active')
  );
  const snap = await getDocs(q);
  return snap.docs
    .map((d) => ({ id: d.id, name: d.data().name, type: d.data().type }))
    .sort((a, b) => a.name.localeCompare(b.name, 'tr', { sensitivity: 'base' }));
}
